var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVeo3 = function SvgVeo3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M15.5 3.02H3.02v9.96H15.5zM16.73.5c.704 0 1.29.586 1.29 1.23v4.395L23 1.145v13.71l-4.98-4.98v4.395c0 .644-.586 1.23-1.29 1.23h-15c-.644 0-1.23-.586-1.23-1.23V1.73C.5 1.086 1.086.5 1.73.5z"
  })));
};
export default SvgVeo3;